import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { CustomElement, element, props, h } from '@wk/custom-element';
import { sprite } from './icons.sprite';
import { DEFAULT_ICON_PREFIX, FILLED_PREFIX, SLUG_CLASS, SLUG_SELECTOR, DEFAULT_SIZE } from './icon.constants';
var Icon = (function (_super) {
    __extends(Icon, _super);
    function Icon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.size = DEFAULT_SIZE;
        _this.filled = false;
        _this.spin = false;
        return _this;
    }
    Icon.prototype.renderedCallback = function () {
        this.injectSprite();
    };
    Icon.prototype.renderCallback = function () {
        var filled = this.filled ? FILLED_PREFIX + "-" : "";
        var link = "#" + DEFAULT_ICON_PREFIX + "-" + filled + this.name;
        var anim = this.spin ? { animation: "spin 2s infinite linear" } : {};
        var style = __assign({ height: this.size + "px", width: this.size + "px", color: this.color }, anim);
        return (h("svg", { style: style, "aria-hidden": "true" },
            this.title && h("title", null, this.title),
            h("use", { href: link })));
    };
    Icon.prototype.injectSprite = function () {
        return __awaiter(this, void 0, void 0, function () {
            var html;
            return __generator(this, function (_a) {
                if (!this.ownerDocument.querySelector(SLUG_SELECTOR)) {
                    html = "<div id=\"" + SLUG_CLASS + "\">" + sprite + "</div>";
                    this.ownerDocument.body.insertAdjacentHTML('beforeend', html);
                }
                return [2];
            });
        });
    };
    __decorate([
        props.string
    ], Icon.prototype, "color", void 0);
    __decorate([
        props.number
    ], Icon.prototype, "size", void 0);
    __decorate([
        props.boolean
    ], Icon.prototype, "filled", void 0);
    __decorate([
        props.string
    ], Icon.prototype, "name", void 0);
    __decorate([
        props.boolean
    ], Icon.prototype, "spin", void 0);
    __decorate([
        props.string
    ], Icon.prototype, "title", void 0);
    Icon = __decorate([
        element('wk-icon')
    ], Icon);
    return Icon;
}(CustomElement));
export { Icon };
